"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchPriceCalcApi = batchPriceCalcApi;
exports.batchPriceUpdateApi = batchPriceUpdateApi;
exports.brandAddApi = brandAddApi;
exports.brandDeleteApi = brandDeleteApi;
exports.brandListAllApi = brandListAllApi;
exports.brandListApi = brandListApi;
exports.brandShowApi = brandShowApi;
exports.brandUpdateApi = brandUpdateApi;
exports.copyConfigApi = copyConfigApi;
exports.copyProductApi = copyProductApi;
exports.debtRatioAddApi = debtRatioAddApi;
exports.debtRatioDeleteApi = debtRatioDeleteApi;
exports.debtRatioListApi = debtRatioListApi;
exports.debtRatioMarkupApi = debtRatioMarkupApi;
exports.debtRatioTiersApi = debtRatioTiersApi;
exports.debtRatioToggleApi = debtRatioToggleApi;
exports.debtRatioUpdateApi = debtRatioUpdateApi;
exports.guaranteeAddApi = guaranteeAddApi;
exports.guaranteeDeleteApi = guaranteeDeleteApi;
exports.guaranteeListApi = guaranteeListApi;
exports.guaranteeShowApi = guaranteeShowApi;
exports.guaranteeUpdateApi = guaranteeUpdateApi;
exports.importProductApi = importProductApi;
exports.offShellApi = offShellApi;
exports.onChangeSalesApi = onChangeSalesApi;
exports.orderExcelApi = orderExcelApi;
exports.productActivityListApi = productActivityListApi;
exports.productAuditApi = productAuditApi;
exports.productBatchAuditApi = productBatchAuditApi;
exports.productBatchVirtualSalesApi = productBatchVirtualSalesApi;
exports.productCategoryAddApi = productCategoryAddApi;
exports.productCategoryApi = productCategoryApi;
exports.productCategoryDeleteApi = productCategoryDeleteApi;
exports.productCategoryListApi = productCategoryListApi;
exports.productCategoryShowApi = productCategoryShowApi;
exports.productCategoryUpdateApi = productCategoryUpdateApi;
exports.productCouponListApi = productCouponListApi;
exports.productDeleteApi = productDeleteApi;
exports.productDetailApi = productDetailApi;
exports.productExcelApi = productExcelApi;
exports.productExportApi = productExportApi;
exports.productHeadersApi = productHeadersApi;
exports.productListbyidsApi = productListbyidsApi;
exports.productLogListApi = productLogListApi;
exports.productLstApi = productLstApi;
exports.productMarketingListApi = productMarketingListApi;
exports.productRatioApi = productRatioApi;
exports.productTagAddApi = productTagAddApi;
exports.productTagDelete = productTagDelete;
exports.productTagInfoApi = productTagInfoApi;
exports.productTagListApi = productTagListApi;
exports.productTagStatusApi = productTagStatusApi;
exports.productTagUpdateApi = productTagUpdateApi;
exports.productToggleShowApi = productToggleShowApi;
exports.putOnShellApi = putOnShellApi;
exports.replyCreatApi = replyCreatApi;
exports.replyDeleteApi = replyDeleteApi;
exports.replyEditApi = replyEditApi;
exports.replyInfoApi = replyInfoApi;
exports.replyListApi = replyListApi;
exports.supplierPricingConfigApi = supplierPricingConfigApi;
exports.supplierPricingUpdateApi = supplierPricingUpdateApi;
exports.updateProductApi = updateProductApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 商品详情
 * @param pram
 */
function productDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/info/".concat(id),
    method: 'GET'
  });
}

// 商品详情-会员权益
function productRatioApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/ratio/page/list",
    method: 'post',
    data: data
  });
}

/**
 * 删除商品
 * @param pram
 */
function productDeleteApi(id, type) {
  return (0, _request.default)({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
function productHeadersApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/tabs/headers',
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表
 * @param pram
 */
function productLstApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品审核
 * @param pram
 */
function productAuditApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/audit",
    method: 'post',
    data: data
  });
}

/**
 * 修改虚拟销量
 * @param pram
 */
function onChangeSalesApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/virtual/sales",
    method: 'post',
    data: data
  });
}

/**
 * 商品分类 分类缓存树
 * @param pram
 */
function productCategoryApi() {
  return (0, _request.default)({
    url: '/admin/platform/product/category/cache/tree',
    method: 'GET'
  });
}
/**
 * 商品分类 列表
 * @param pram
 */
function productCategoryListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/category/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品分类 新增
 * @param pram
 */
function productCategoryAddApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/category/add',
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 编辑
 * @param pram
 */
function productCategoryUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/category/update',
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 删除
 * @param pram
 */
function productCategoryDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/category/delete/".concat(id),
    method: 'post'
  });
}
/**
 * 商品分类 修改分类显示状态
 * @param pram
 */
function productCategoryShowApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/category/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 商品上架
 * @param pram
 */
function putOnShellApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品强制下架
 * @param pram
 */
function offShellApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/force/down",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 列表
 * @param pram
 */
function replyListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
function replyCreatApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
function replyEditApi(data) {
  return (0, _request.default)({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
function replyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
function replyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
function productExportApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
function importProductApi(params) {
  return (0, _request.default)({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
function copyProductApi(data) {
  return (0, _request.default)({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
function productExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
function copyConfigApi() {
  return (0, _request.default)({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}

/**
 * 品牌 列表
 * @param pram
 */
function brandListApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/list",
    method: 'get',
    params: params
  });
}

/**
 * 品牌缓存列表(全部)
 * @param pram
 */
function brandListAllApi() {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/cache/list",
    method: 'get'
  });
}

/**
 * 品牌 新增
 * @param pram
 */
function brandAddApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/add",
    method: 'post',
    data: data
  });
}

/**
 * 品牌 编辑
 * @param pram
 */
function brandUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/update",
    method: 'post',
    data: data
  });
}

/**
 * 品牌 删除
 * @param pram
 */
function brandDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 品牌 修改品牌显示状态
 * @param pram
 */
function brandShowApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/brand/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 列表
 * @param pram
 */
function guaranteeListApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/product/guarantee/list",
    method: 'get',
    params: params
  });
}

/**
 * 保障服务 新增
 * @param pram
 */
function guaranteeAddApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/guarantee/add",
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 编辑
 * @param pram
 */
function guaranteeUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/guarantee/update",
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 删除
 * @param pram
 */
function guaranteeDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/guarantee/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 修改品牌显示状态
 * @param pram
 */
function guaranteeShowApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/guarantee/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 修改商品
 * @param pram
 */
function updateProductApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/update",
    method: 'post',
    data: data
  });
}

/**
 * 商品可用优惠券列表
 * @param pram
 */
function productCouponListApi() {
  return (0, _request.default)({
    url: '/admin/platform/coupon/product/usable/list',
    method: 'get'
  });
}

/**
 * 商品搜索分页列表（活动），diy中使用
 * @param pram
 */
function productActivityListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/activity/search/page',
    method: 'get',
    params: params
  });
}

/**
 * 根据商品id集合查询商品列表
 * @param pram
 */
function productListbyidsApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/listbyids",
    method: 'post',
    data: data
  });
}

/**
 * 商品标签列表
 * @param params 查询参数
 * @returns {*} 查询结果
 */
function productTagListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/producttag/list",
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      keywords: encodeURI(params.keywords)
    })
  });
}

/**
 * 商品标签删除
 * @param id 待删除id
 * @returns {*}
 */
function productTagDelete(id) {
  return (0, _request.default)({
    url: "/admin/platform/producttag/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商品标签详情
 * @param id
 * @returns {*}
 */
function productTagInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/producttag/info/".concat(id),
    method: 'get'
  });
}

/**
 * 新增商品标签
 * @param data 待新增数据
 * @returns {*} 新增结果
 */
function productTagAddApi(data) {
  return (0, _request.default)({
    url: "admin/platform/producttag/save",
    method: 'post',
    data: data
  });
}

/**
 * 编辑商品标签
 * @param data 待编辑数据
 * @returns {*} 新增结果
 */
function productTagUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/producttag/update",
    method: 'post',
    data: data
  });
}

/**
 * 更新标签状态
 * @param id 标签id
 * @param status 标签状态
 * @returns {*}
 */
function productTagStatusApi(id, status) {
  return (0, _request.default)({
    url: "/admin/platform/producttag/status/".concat(id, "/").concat(status),
    method: 'get'
  });
}

/**
 * 平台端批量商品审核
 * @returns {*}
 */
function productBatchAuditApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/batch/audit",
    method: 'post',
    data: data
  });
}

/**
 * 平台端商品显示/隐藏切换
 * @param id 商品id
 */
function productToggleShowApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/product/toggle/show/".concat(id),
    method: 'post'
  });
}

/**
 * 批量设置虚拟销量
 * @returns {*}
 */
function productBatchVirtualSalesApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/product/batch/set/virtual/sales",
    method: 'post',
    data: data
  });
}

/**
 * 商品搜索分页列表（营销）
 * @param pram
 */
function productMarketingListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/product/marketing/search/page',
    method: 'get',
    params: params
  });
}

/**
 * 商品操作记录分页列表
 * @param pram
 */
function productLogListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/log/product/log/list',
    method: 'GET',
    params: params
  });
}

/**
 * 批量改价预计算
 * @param data
 */
function batchPriceCalcApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/batch/price/calc',
    method: 'post',
    data: data
  });
}

/**
 * 批量改价提交
 * @param data
 */
function batchPriceUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/product/batch/price/update',
    method: 'post',
    data: data
  });
}

/**
 * 获取供应商生效的债权档位列表
 * @param merId
 */
function debtRatioTiersApi(merId) {
  return (0, _request.default)({
    url: "/admin/platform/debt/ratio/tiers/".concat(merId),
    method: 'get'
  });
}

/**
 * 获取供应商指定档位的上浮参数
 * @param params
 */
function debtRatioMarkupApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/debt/ratio/markup',
    method: 'get',
    params: params
  });
}

/**
 * 债权档位全局配置 - 列表
 */
function debtRatioListApi() {
  return (0, _request.default)({
    url: '/admin/platform/debt/ratio/list',
    method: 'get'
  });
}

/**
 * 债权档位全局配置 - 新增
 */
function debtRatioAddApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/debt/ratio/add',
    method: 'post',
    data: data
  });
}

/**
 * 债权档位全局配置 - 编辑
 */
function debtRatioUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/debt/ratio/update',
    method: 'post',
    data: data
  });
}

/**
 * 债权档位全局配置 - 删除
 */
function debtRatioDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/debt/ratio/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 债权档位全局配置 - 切换启用/停用
 */
function debtRatioToggleApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/debt/ratio/toggle/".concat(id),
    method: 'post'
  });
}

/**
 * 供应商定价配置 - 查询
 */
function supplierPricingConfigApi(merId) {
  return (0, _request.default)({
    url: "/admin/platform/supplier/pricing/config/".concat(merId),
    method: 'get'
  });
}

/**
 * 供应商定价配置 - 更新
 */
function supplierPricingUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/supplier/pricing/config/update',
    method: 'post',
    data: data
  });
}